module.exports = __webpack_public_path__ + "img/place.fa3740ff.png";